export default __webpack_public_path__ + "static/allred-5e108d33dd98bad37b6280d169c225e1.jpg";